import { isSuperAdmin } from "../../components/Common/CheckAuthorization";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const FIELDS = {
  getMandatoryFieldsList: {
    start: "GET_MANDATORY_FIELDS_STARTED",
    success: "GET_MANDATORY_FIELDS_LIST"
  },
  update: {
    start: "FIELD_UPDATE_STATRTED",
    success: "FIELD_UPDATE_SUCCESS",
    error: "FIELD_UPDATE_ERROR"
  }
};

export const getMandatoryFieldsList = formName => {
  return (dispatch,getState) => {
    const selectedMainFarm =getState().FarmManagementReducer.MainFarmId
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url =  !userDetail().parentFarmId  ? `/ntrac/field/modify/getAllFieldsDetails/${formName}/${selectedMainFarm}`
    : `/ntrac/field/modify/getAllFieldsDetails/${formName}`;
    dispatch({ type: FIELDS.getMandatoryFieldsList.start });
    return globalApiHandler(url, "get", {})
      .then(response => {
        let data = response.data.data;
        data = data.filter(item => item.isVisible === true);
        dispatch({ type: FIELDS.getMandatoryFieldsList.success, data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return [];
      });
  };
};

export const updateMandatoryField = requestData => {
  let url = isSuperAdmin() ? `/ntrac/field/modify/put` : `/ntrac/field/modify/user/put`;
  return dispatch => {
    dispatch({ type: FIELDS.update.start });
    globalApiHandler(url, "put", requestData)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: FIELDS.update.success, data });
      })
      .catch(err => {
        dispatch({ type: FIELDS.update.error, data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/mandatoryFields/action.js